import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import axios from "axios";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";
import { CreateOrgRequest } from "../types/org.type";

const createOrg = async ({
  companyName,
  companyRegistrationNo,
  countryISOCode,
  industryGroup,
  industry,
  legalEntityAddress,
  legalStructure,
  onBoardingUserType,
  postalCode,
  bank,
  token,
  firstName,
  lastName,
  nameOfAuthorisedRepresentiative,
  occupation,
  numberofYears,
  nationality,
  gender,
  employmentStatus,
  employmentPosition,
  dateOfBirth,
  countryOfBirth,
  isPep,
  investmentPreferences,
  documentsUpload,
  companyPhoneNumber,
  titleOfAuthorisedRepresentiative,
  countryOfIncorporation,
  previousYearClosingInventory,
  website,
  shareHolders,
  boardOfDirectors,
  emailOfAuthorisedRepresentiative,
  jobTitle,
  companyStartDate,
  employerName,
  referralSource,
  otherReferral,
  numberOfTaxResidenceCountries,
  taxResidenceCountries,
  city,
  region,
}: CreateOrgRequest) => {
  try {
    const response = await axios.post(
      `${getBaseUrl(Microservice.TRADE_DIRECTORY)}/trade-directory/organization`,
      {
        companyName,
        companyRegistrationNo,
        countryISOCode,
        industryGroup,
        industry,
        legalEntityAddress,
        legalStructure,
        onBoardingUserType,
        postalCode,
        bank,
        firstName,
        lastName,
        nameOfAuthorisedRepresentiative,
        occupation,
        numberofYears,
        nationality,
        gender,
        employmentStatus,
        employmentPosition,
        dateOfBirth,
        countryOfBirth,
        isPep,
        investmentPreferences,
        documentsUpload,
        companyPhoneNumber,
        titleOfAuthorisedRepresentiative,
        countryOfIncorporation,
        previousYearClosingInventory,
        website,
        shareHolders,
        boardOfDirectors,
        emailOfAuthorisedRepresentiative,
        jobTitle,
        companyStartDate,
        employerName,
        referralSource,
        otherReferral,
        numberOfTaxResidenceCountries,
        taxResidenceCountries,
        city,
        region,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      }
    );

    return response.data;
  } catch (e) {
    const message = getApiResponseErrorMsg(e);

    throw new Error(message);
  }
};

export default createOrg;
